import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const itemDistributionList = createAsyncThunk(
  'school-item-distribution-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-item-distribution/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeItemDistribution = createAsyncThunk(
  'school-item-distribution-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-item-distribution/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getItemDistributionById = createAsyncThunk(
  'school-item-distribution-get',
  async (distribution_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-item-distribution/edit/` + distribution_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const approveItemDistribution = createAsyncThunk(
  'school-item-distribution-approve',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-item-distribution/approve/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewItemDistribution = createAsyncThunk(
  'school-item-distribution-view',
  async (distribution_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-item-distribution/view/` + distribution_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getItemExistsItemList = createAsyncThunk(
  'school-item-distribution-exists-item-list',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-item-distribution/get-school-item-stock`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type DistributionState = {
  errors: any
}

const initialState: DistributionState = {
  errors: '',
}

export const itemDistributionSlice = createSlice({
  name: 'distribution',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeItemDistribution.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = itemDistributionSlice.actions
export default itemDistributionSlice.reducer
